import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

// TODO-electron-post-release-onur: Update when design is ready (cross color will be white)
function IconClose({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0zm1.941 3.766L7 5.708 5.059 3.766a.918.918 0 0 0-1.29.003.91.91 0 0 0-.003 1.29L5.708 7 3.766 8.941a.918.918 0 0 0 .003 1.29.91.91 0 0 0 1.29.002L7 8.293l1.941 1.94a.918.918 0 0 0 1.29-.002.91.91 0 0 0 .002-1.29L8.293 7l1.94-1.941a.918.918 0 0 0-.002-1.29.91.91 0 0 0-1.29-.003z"/>
        </svg>
    );
}

export default IconClose;

